import React from 'react';

import { Colors } from 'enums/Colors';
import { Badge } from 'components/Badge';
import { Icon } from 'components/tokens/Icon';
import { arrowRight } from 'icons/default';

import styles from './FlowCard.module.scss';

export interface FlowCardProps {
  title: string;
  subtitle?: string;
  badgeLabel?: string;
  badgeColor?: Colors;
  image?: JSX.Element;
  showArrow?: boolean;
}

export const FlowCard: React.FC<FlowCardProps> = ({
  title,
  subtitle,
  badgeLabel,
  badgeColor,
  image,
  showArrow = false,
}) => (
  <div className={styles.container}>
    {image && image}
    <div>
      <h3 className={styles.title}>{title}</h3>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </div>
    {badgeLabel && (
      <div className={styles.badge}>
        <Badge color={badgeColor} size="small" isInverted>
          {badgeLabel}
        </Badge>
      </div>
    )}

    {showArrow && (
      <div className={styles.arrow}>
        <Icon icon={arrowRight} />
      </div>
    )}
  </div>
);
